import { Component, EventEmitter, OnInit, OnDestroy, Output, Input } from '@angular/core';
import { GrowProject } from '@inyova/grow';
import { AmplitudeService } from '@inyova/inyova-shared';
import { CustomerAccount } from '@inyova/models';

import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { isProjectMarkedForInterest } from '../../grow.reducers';

import { LanguageService } from '@shared/services/language.service';

import * as GrowActions from '../../grow-actions';

export enum TabList {
  DETAILS,
  RISKS,
  OPPORTUNITIES,
  IMPACT
}
@Component({
  selector: 'app-grow-project-detail-dialog',
  styleUrls: ['./grow-project-detail.component.scss'],
  templateUrl: './grow-project-detail.component.html',
  standalone: false
})
export class GrowProjectDetailComponent implements OnInit, OnDestroy {
  @Input() growAccount: CustomerAccount;
  @Input() project: GrowProject;

  @Output() closeProject: EventEmitter<void> = new EventEmitter<void>();

  language: string;

  isMarked$: Observable<boolean>;
  protected readonly onDestroy$ = new Subject<void>();

  constructor(
    private languageService: LanguageService,
    private store: Store,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit(): void {
    this.isMarked$ = this.store.select(isProjectMarkedForInterest(this.project.id)).pipe(takeUntil(this.onDestroy$));
    this.languageService.selected.pipe(takeUntil(this.onDestroy$)).subscribe((language) => {
      this.language = language;
    });
  }

  onClose() {
    this.closeProject.emit();
  }

  markProject() {
    this.amplitudeService.trackEvent('Project Selected', {
      project_name: this.project.title,
      intrest_rate: this.project.expected_return,
      maturity_date: new Date(this.project.end_date).toISOString(),
      project_id: this.project.id,
      minimum_investment: this.project.minimum_funding,
      currency: this.project.currency,
      investment_sector: this.project.sector,
      placement: 'onboarding'
    });
    this.store.dispatch(GrowActions.markGrowProject({ projectId: this.project.id }));
    this.onClose();
  }

  unmarkProject() {
    this.amplitudeService.trackEvent('Project Unselected', {
      project_name: this.project.title,
      intrest_rate: this.project.expected_return,
      maturity_date: new Date(this.project.end_date).toISOString(),
      project_id: this.project.id,
      minimum_investment: this.project.minimum_funding,
      currency: this.project.currency,
      investment_sector: this.project.sector,
      placement: 'onboarding'
    });
    this.store.dispatch(GrowActions.unmarkGrowProject({ projectId: this.project.id }));
    this.onClose();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onTabChanged(tabId: number) {
    const tabListMap = {
      [TabList.DETAILS]: 'details',
      [TabList.RISKS]: 'risk',
      [TabList.OPPORTUNITIES]: 'opportunities',
      [TabList.IMPACT]: 'impact'
    };
    this.amplitudeService.trackEvent('Project Details Viewed', {
      project_name: this.project.title,
      intrest_rate: this.project.expected_return,
      maturity_date: new Date(this.project.end_date),
      project_id: this.project.id,
      minimum_investment: this.project.minimum_funding,
      currency: this.project.currency,
      investment_sector: this.project.sector,
      project_details_section_viewed: tabListMap[tabId],
      placement: 'onboarding'
    });
  }
}
